import type { SelectableFieldsResponse } from '../models/selectableFields.types'
import { parseSelectableFields } from '../models/selectableFields.wire'

import { appHttp, decodeDto, unwrap } from '@/shared/http'

/**
 * Legacy parity (`useSelectableFields.ts`): which fields a workspace can actually offer for one
 * report partition, straight from the backend's single producer (`common/workspace_catalog`,
 * ORP-19643). Distinct from — and more authoritative than — the bootstrap-driven static level
 * catalog (`useLevelMetadata`'s `tableDimensions`/`tableMetrics`), which can list zero fields for
 * a partition a workspace genuinely has data for.
 */
export class SelectableFieldsApi {
  constructor(private readonly app: Pick<typeof appHttp, 'get'> = appHttp) {}

  async fetchSelectableFields(
    accountId: number | string,
    workspaceId: number | string,
    partitionName: string,
  ): Promise<SelectableFieldsResponse> {
    const response = await this.app.get<unknown>(
      `/accounts/${accountId}/workspace/${workspaceId}/selectable_fields`,
      {
        params: { partition_name: partitionName },
        // An empty list is a valid terminal answer (no tab on this partition), not a failure the
        // global handler should surface — the composable's own empty state covers it.
        suppressGlobalErrorHandler: true,
        meta: { suppressGlobalErrorHandler: true },
      },
    )
    return decodeDto(unwrap(response), parseSelectableFields)
  }
}

export const selectableFieldsApi = new SelectableFieldsApi()
